import React, { useEffect, JSX } from "react";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { WrappedComponentProps, injectIntl, useIntl } from "react-intl";
import { translateMessage } from "src/app/methods/translateMessage";
import { CustomInputLabel } from "../../../../components/CustomInput/CustomInput";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
import { ModalColumn } from "../../../../components/Modal/Modal";
import { MFState, SetStateFn } from "../../types";

interface Props extends WrappedComponentProps<"intl"> {
  state: MFState;
  setState: SetStateFn;
  isEdited: boolean;
  globalFieldMode?: boolean;
}

export interface SelectOption {
  value: any;
  label: JSX.Element;
}

function SalesMetrics(props: Props) {
  const {
    state: { salesMetrics, salesMetricOptions, selectedMetrics },
    setState,
    isEdited,
    globalFieldMode,
  } = props;

  const intl = useIntl();

  useEffect(() => {
    if (Object.keys(salesMetrics).length) {
      setState("selectedMetrics", []);
      setState(
        "salesMetricOptions",
        Object.entries(salesMetrics).map((e: any) => {
          return {
            label: e[1].key,
            value: e[0],
            type: e[1].type,
            icon: e[1].icon,
          };
        }),
      );
    }
  }, [salesMetrics]);

  useEffect(() => {
    if (salesMetricOptions?.length) {
      setState("dataApplied", true);
    }
  }, [salesMetricOptions]);

  const handleChange = (newValue: SelectOption) => {
    const newSelectedMetrics = globalFieldMode ? [newValue] : newValue;
    setState("selectedMetrics", newSelectedMetrics);
  };

  const getMetricsValue = () => {
    if (globalFieldMode) {
      return selectedMetrics[0] || {};
    }

    return selectedMetrics;
  };

  return (
    <div className="sales-metrics metric-wrapper metric-wrapper--no-margin">
      <ModalColumn>
        <CustomInputLabel htmlFor="metric">
          <IDHFormattedMessage id="ws_metric" defaultMessage="Metric" />
        </CustomInputLabel>
        <CustomSelect
          id="metric"
          value={getMetricsValue()}
          options={salesMetricOptions}
          placeholder={translateMessage({
            intl,
            id: "ws_select_metric",
            defaultMessage: "Select metric",
          })}
          closeMenuOnSelect={globalFieldMode || false}
          isMulti={!globalFieldMode}
          isSearchable
          onChange={handleChange}
          disabled={isEdited}
        />
      </ModalColumn>
    </div>
  );
}

export default injectIntl(SalesMetrics);
